<!--
 * @Author: guoyu
 * @Date: 2020-09-17 11:17:57
 * @LastEditors: zheng zheng@sence.sg
 * @LastEditTime: 2022-12-08 11:36:10
 * @Description: b端退款
-->
<template>
  <div class="popup-container">
    <div v-if="dialogloading" class="loading-line">
      <p>
        <i class="el-icon-loading" />
      </p>
    </div>
    <template v-else>
      <!-- v-show="refoundCount !== 1" -->
      <div class="refound-item">
        <div class="item-label">退款單數</div>
        <GInputNumber
          class="refound-count"
          v-if="canRefoundCount"
          v-model="refoundCount"
          :max="canRefoundCount"
        ></GInputNumber>
        <span class="no-count" v-else>暫無可退訂單</span>
      </div>
      <div class="refound-item">
        <div class="item-label">退款金額</div>
        <div class="refound-amount">{{ refoundAmount }}</div>
      </div>
      <div class="refound-item">
        <div class="item-label">退款理由</div>
        <div>
          <el-select
            class="reason-picker-val input-tip"
            v-model="refoundReson.value"
            placeholder="請填寫您的退款理由"
          >
            <el-option
              v-for="item in reasonList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="refound-item mg-b-64">
        <div class="item-label mg-b-24">
          退款詳細說明<span class="input-tip">(必填)</span>
        </div>
        <FpsTextArea
          class="reason-text"
          v-model="reasonDetail"
          placeholder="請輸入退款理由"
        ></FpsTextArea>
      </div>
      <div class="refound-item">
        <div class="item-label mg-b-24">
          上傳憑證<span class="input-tip">(非必填)</span>
        </div>
        <UploadImg class="reason-imgs" :max="5" v-model="images"></UploadImg>
      </div>
      <div class="refound-footer" v-if="orderInfo && canRefoundCount">
        <div
          class="refound-submit"
          :class="{ 'allow-submit': allowSubmit }"
          @click="refoundOrder"
        >
          提交退款申請
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import GInputNumber from '@/components/common/input/input-number';
import UploadImg from '@/components/common/upload/upload-image';
import FpsTextArea from '@/components/common/input/text-area';
import PopupMixin from '@/components/common/popup/general';
export default {
  mixins: [PopupMixin],
  components: {
    GInputNumber,
    UploadImg,
    FpsTextArea,
  },
  props: {
    dialogloading: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      refoundReson: {},
      reasonDetail: '',
      refoundCount: 1,
      popupOpen: false,
      images: [],
      reasonList: [
        { text: '下單用戶同意退款', value: 'C_AGREE' },
        { text: '無法滿足下單用戶需求', value: 'UNABLE_MEET_DEMAND' },
        { text: '用戶有違規行為', value: 'USER_VIOLATIONS' },
        { text: '其他', value: 'OTHER' },
      ],
      pageLoaded: false,
    };
  },
  computed: {
    refoundAmount() {
      if (!this.orderInfo || !this.canRefoundCount) return 0;
      let payAmount = this.orderInfo.currentAmount;
      let payCount = this.orderInfo.orderItemVoList[0].count;
      return parseInt((this.refoundCount / payCount) * payAmount);
    },
    hasRefound() {
      if (!this.orderInfo) return 0;
      return (
        this.$util.getVal(
          this.orderInfo,
          'tradeRefundInfo.tradeRefundDetailList.0.refundNum'
        ) || 0
      );
    },
    canRefoundCount() {
      if (!this.orderInfo) return 1;
      return this.orderInfo.orderItemVoList[0].count - this.hasRefound;
    },
    allowSubmit() {
      return ['reasonDetail', 'refoundReson.value'].every((key) => {
        return this.$util.getVal(this, key);
      });
    },
  },
  methods: {
    checkNull() {
      return [
        { key: 'reasonDetail', msg: '請填寫退款說明' },
        { key: 'refoundReson.value', msg: '請選擇退款原因' },
      ].some((item) => {
        let { key, msg } = item;
        if (!this.$util.getVal(this, key)) {
          this.$message(msg);
          return true;
        }
      });
    },
    async refoundOrder() {
      if (this.checkNull() || this.refounding) return;
      let refoundConfirm = await this.$confirm(
        {
          content: '退款後將無法進行修改，確認退款嗎？',
          confirmButtonText: '再想想',
          cancelButtonText: '繼續退款',
        }
      )
        .then(() => {
          return false;
        })
        .catch(() => {
          return true;
        });
      if (!refoundConfirm) return;
      this.refounding = true;
      this.$http
        .post('/tradeRefund/playerApplyRefund', {
          applyUuid: this.userInfo.uuid,
          desc: this.reasonDetail,
          images: this.images,
          orderNo: this.orderInfo.orderNo,
          refundApplyKind: 'B_REFUND',
          refundItemList: [
            {
              refundNum: this.refoundCount,
              salesUnit: this.orderInfo.orderItemVoList[0].salesUnit,
              skillId: this.orderInfo.orderItemVoList[0].playerSkillId,
            },
          ],
          refundReason: this.refoundReson.value,
        })
        .then(() => {
          this.refounding = false;
          this.$emit('handleRoundExplain', 'borderRoundDetail');
        })
        .catch(() => {
          this.refounding = false;
          this.$message('網絡忙');
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-line {
  height: 40px;
  margin: 30px auto 0;

  p {
    @include flex();
    height: 40px;
  }

  i {
    font-size: 1.6em;
  }
}
.popup-container {
  width: 375px;
  padding-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
}
.header-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 18px;
  border-bottom: 1px solid #e8eaee;
  font-weight: 500;
  font-size: 18px;
  color: $color-gray-1;
}
.refound-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  min-height: 54px;
  padding: 0 18px;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
}
.refound-count {
  border: none;
  /deep/ .minus,
  /deep/ .plus {
    width: 30px;
    height: 30px;
    background: #f2f2f2;
    border: 2px solid #dddddd;
    box-sizing: border-box;
    border-radius: 8px;
    &::after {
      background: #666666;
    }
  }
  /deep/ .vertical {
    background: #666666;
  }
}
.item-label {
  font-weight: 500;
}
.refound-amount {
  color: $color-orange;
}
.reason-text {
  width: 100%;
}
.reason-imgs {
  width: 100%;
  font-size: 0;
  line-height: 0;
}
.mg-b-24 {
  margin-bottom: 12px;
}
.mg-b-64 {
  margin-bottom: 32px;
}
.input-tip {
  font-weight: 400;
  color: #8c94aa;
}
.picker-arrow {
  vertical-align: middle;
  font-weight: 700;
}
.reason-picker-val {
  font-size: 14px;
  /deep/ .el-input__inner {
    border: none;
    text-align: right;
  }
  /deep/ .el-input__inner::-webkit-input-placeholder {
    font-size: 14px;
    font-weight: 400;
  }
}
.refound-footer {
  padding: 44px 16px 10px;
}
.refound-submit {
  width: 100%;
  height: 48px;
  text-align: center;
  line-height: 48px;
  font-weight: 500;
  font-size: 16px;
  color: #636d86;
  background: $color-button;
  border-radius: 25px;
  cursor: pointer;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 360px;
  height: 300px;
}
.no-count {
  font-weight: 400;
  color: #8c94aa;
}
.allow-submit {
  @include button-yellow;
}
</style>
